// Bebawa_NewDesignSystem / Currrency (Figma 2641:198940). Each coin is exported
// pre-cropped to the circle the design clips to, on a transparent square, so
// consumers can render it directly without a mask.
import audCoin from './icons/currency/coins/aud.png?url';
import cadCoin from './icons/currency/coins/cad.png?url';
import chfCoin from './icons/currency/coins/chf.png?url';
import cnhCoin from './icons/currency/coins/cnh.png?url';
import czkCoin from './icons/currency/coins/czk.png?url';
import dkkCoin from './icons/currency/coins/dkk.png?url';
import eurCoin from './icons/currency/coins/eur.png?url';
import gbpCoin from './icons/currency/coins/gbp.png?url';
import jpyCoin from './icons/currency/coins/jpy.png?url';
import krwCoin from './icons/currency/coins/krw.png?url';
import mxnCoin from './icons/currency/coins/mxn.png?url';
import plnCoin from './icons/currency/coins/pln.png?url';
import uahCoin from './icons/currency/coins/uah.png?url';
import usdCoin from './icons/currency/coins/usd.png?url';

export const currencyCoinIcons = {
  AUD: audCoin,
  CAD: cadCoin,
  CHF: chfCoin,
  CNH: cnhCoin,
  CZK: czkCoin,
  DKK: dkkCoin,
  EUR: eurCoin,
  GBP: gbpCoin,
  JPY: jpyCoin,
  KRW: krwCoin,
  MXN: mxnCoin,
  PLN: plnCoin,
  UAH: uahCoin,
  USD: usdCoin,
} as const;

export type CurrencyCoinCode = keyof typeof currencyCoinIcons;

export const getCurrencyCoinIcon = (code: string): string | undefined => {
  return currencyCoinIcons[code as CurrencyCoinCode];
};

// The `*Icon` and `accounts*Icon` names predate the coin set and are kept so the
// screens using them pick up the new art without a call-site change.
const euroIcon = currencyCoinIcons.EUR;
const usdIcon = currencyCoinIcons.USD;
const gbrIcon = currencyCoinIcons.GBP;
const cnhIcon = currencyCoinIcons.CNH;
const accountsEuroIcon = currencyCoinIcons.EUR;
const accountsUsdIcon = currencyCoinIcons.USD;
const accountsGbrIcon = currencyCoinIcons.GBP;

export const currencyIcons = {
  EUR: euroIcon,
  USD: usdIcon,
  GBP: gbrIcon,
  EUR_ACCOUNTS: accountsEuroIcon,
  USD_ACCOUNTS: accountsUsdIcon,
  GBP_ACCOUNTS: accountsGbrIcon,
} as const;

export { euroIcon, usdIcon, gbrIcon, cnhIcon };

// Transaction direction icons
import cardOutIcon from './icons/card-out.png?url';
import outIcon from './icons/out.png?url';
import inIcon from './icons/in.png?url';

export { cardOutIcon, outIcon, inIcon, accountsEuroIcon, accountsUsdIcon, accountsGbrIcon };
